import { render } from "./ChooseParty.vue?vue&type=template&id=8da16264&scoped=true&ts=true"
import script from "./ChooseParty.vue?vue&type=script&lang=ts"
export * from "./ChooseParty.vue?vue&type=script&lang=ts"

import "./ChooseParty.vue?vue&type=style&index=0&id=8da16264&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da16264"]])

export default __exports__